import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './queryRateChangeList.json';

const queryRateChangeList = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['rateController/queryRateChangeList'].success[req.body.path])));
};

export const handlers = [
  rest.post(getApiEndpoint('rateController/queryRateChangeList'), withScenario(withAuthCheck(queryRateChangeList))),
];
